// src/slices/helpSlice.js

import { createSlice } from '@reduxjs/toolkit';
import { addHelpThunk } from './helpThunk';

const helpSlice = createSlice({
    name: 'help',
    initialState: {
        addHelpThunkLoading: false,
        addHelpThunkError: null,
        addHelpThunkFullfill: null
    },
    reducers: {
        resetHelpState: (state) => {
            state.addHelpThunkLoading = false;
            state.addHelpThunkError = null;
            state.addHelpThunkFullfill = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(addHelpThunk.pending, (state) => {
                state.addHelpThunkLoading = true;
                state.addHelpThunkError = null;
            })
            .addCase(addHelpThunk.fulfilled, (state, action) => {
                state.addHelpThunkLoading = false;
                state.addHelpThunkFullfill = action.payload.message;
            })
            .addCase(addHelpThunk.rejected, (state, action) => {
                state.addHelpThunkLoading = false;
                state.addHelpThunkError = action.payload || 'Something went wrong!';
            });
    },
});

export const { resetHelpState } = helpSlice.actions;
export default helpSlice.reducer;
